import { Box, Button, Typography } from "@mui/material";
import { useForm, FormProvider } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { EmailTextField } from "./TextField";
import { ForgotPasswordFormData, forgotPasswordSchema } from "./validationSchema";

interface ForgotPasswordFormProps {
    onSubmit: (data: ForgotPasswordFormData) => void;
    onBack: () => void;
}

export default function ForgotPasswordForm({ onSubmit, onBack }: ForgotPasswordFormProps) {
    const methods = useForm<ForgotPasswordFormData>({
        resolver: zodResolver(forgotPasswordSchema),
        mode: "onChange"
    });
    const { formState } = methods;

    return (
        <FormProvider {...methods}>
            <Box component="form" onSubmit={methods.handleSubmit(onSubmit)}>
                <Typography variant="h4" textAlign="center" gutterBottom color="primary">
                    Forgot Password
                </Typography>
                <EmailTextField label="Email" placeholder="Enter your email" fullWidth margin="normal" />
                <Button variant="contained" type="submit" fullWidth sx={{ mt: 2 }} disabled={!formState.isValid}>
                    Submit
                </Button>
                <Button variant="text" type="button" fullWidth sx={{ mt: 1 }} onClick={onBack}>
                    Back to Login
                </Button>
            </Box>
        </FormProvider>
    );
}
